import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flashlight-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 tracking-wide">吃瓜爆料</span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              汇集全网最热的吃瓜爆料内容，每日更新明星黑料、网红翻车、社会热点、娱乐圈内幕、电竞圈爆料，让你吃瓜吃到饱。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">更多分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                品牌介绍
              </Link>
              <a href="/about#reputation" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                口碑评价
              </a>
              <a href="/about#contact" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-500">
            &copy; 2026 吃瓜爆料 - 每日热点爆料吃瓜，版权所有。
          </p>
          <div className="flex items-center gap-4 text-sm text-secondary-500">
            <span>关注我们</span>
            <a href="#" className="hover:text-accent-400 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="hover:text-accent-400 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="hover:text-accent-400 transition-colors duration-200" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}